import DisabledEmptyState from './DisabledEmptyState';
import DisabledEmptyStateContainer from './DisabledEmptyState.container';

export default DisabledEmptyStateContainer(DisabledEmptyState);
